import { Button, ColorTypes, DropdownMenu, IconSpec, dom } from "@omegagrid/core";
import { FolderOptions, NodeModel, NodeSource, TreeAdapter, TreeOptions } from "@omegagrid/tree";
import { Browser, BrowserMenuItem } from "./browser";
import { TemplateResult, render, html } from "lit";

export type BrowserOptions = TreeOptions & {
	contextMenuButton?: boolean;
}

export abstract class BrowserAdapter extends TreeAdapter {

	browser: Browser;

	static folderOptions: FolderOptions = {
		openIcon: {icon: ['fas', 'folder-open'], color: '#dcb67a'},
		closedIcon: {icon: ['fas', 'folder'], color: '#dcb67a'},
	}

	static fileConfig = new Map<string, {icon: IconSpec}>([
		['sql', {icon: {icon: 'database'}}],
		['yaml', {icon: {icon: 'file-code'}}],
		['json', {icon: {icon: 'file-code'}}],
	]);

	getFileConfigByName = (filename: string) => {
		const match = /\.([^.]+)$/.exec(filename);
		return BrowserAdapter.fileConfig.get(match ? match[1] : null);
	}

	getMenuItems(node: NodeModel): null|BrowserMenuItem[]|Promise<BrowserMenuItem[]> {
		return null;
	}

	getTooltip(node: NodeModel): string|TemplateResult<1>|Promise<string|TemplateResult<1>> {
		return null;
	}

	onAction(action: string, node: NodeModel): void|Promise<void> { }

	getOptions(): Partial<BrowserOptions> | Promise<Partial<BrowserOptions>> {
		return null;	
	}

	private _renderNode(
		div: HTMLDivElement, 
		node: NodeModel, 
		customRenderer?: (div: HTMLDivElement, node: NodeModel) => void
	) {
		const txtDiv = dom.createElement<HTMLDivElement>('div');
		txtDiv.style.flex = '1';
		txtDiv.style.overflow = 'hidden';
		txtDiv.style.textOverflow = 'ellipsis';
		txtDiv.style.whiteSpace = 'nowrap';
		txtDiv.style.justifyContent = 'center';

		if (customRenderer) customRenderer(txtDiv, node);
		else txtDiv.textContent = node.value;
		
		// remove all children except the first icon
		while (div.children.length > 1) {
			div.removeChild(div.children[div.children.length - 1]);
		}
		
		div.style.display = 'flex';
		div.style.flexDirection = 'row';
		div.appendChild(txtDiv);
	};

	private _renderNodeWithMenu(
		div: HTMLDivElement, 
		node: NodeModel, 
		customRenderer?: (div: HTMLDivElement, node: NodeModel) => void
	) {
		this._renderNode(div, node, customRenderer);
		const btnMenu = dom.createElement<Button>('og-button', {color: ColorTypes.Transparent, icon: 'ellipsis'});
		btnMenu.style.textAlign = 'left';
		btnMenu.style.flex = '0 0 25px';
		btnMenu.style.marginRight = '10px';
		btnMenu.addEventListener('mousedown', (e: MouseEvent) => {
			btnMenu.addEventListener('mouseup', (e: MouseEvent) => e.stopPropagation(), {once: true});
			e.stopPropagation();
			this.browser.openMenu(node, btnMenu);
		});
		div.appendChild(btnMenu);
	};

	protected createOptions(options: Partial<BrowserOptions>): BrowserOptions {
		options = Object.assign({}, options);
		if (!options.contextMenuButton) return options;
		const nodeRenderer = options.nodeRenderer;
		options.nodeRenderer = (div: HTMLDivElement, node: NodeModel) => {
			Promise.all([this.getMenuItems(node)]).then(items => {
				if (items[0]?.length) {
					this._renderNodeWithMenu(div, node, nodeRenderer);
				} else if (nodeRenderer) {
					nodeRenderer(div, node);
				} else {
					this._renderNode(div, node);
				}
			});
		};
		return options;
	}

}
